<button
type="button"
class="agregar btn btn-success aparece-cuatro"
routerLink="/perfil-nuevo01"
routerLinkActive="active-link">
    <span>Nuevo contrato</span>
    <i class="fa-solid fa-plus"></i>
</button>